module.exports = __webpack_public_path__ + "img/bd-closeBtn-pop.eb915ee2.png";